module.exports = __webpack_public_path__ + "static/media/Arrow.dd7b9b86.svg";